import { render, staticRenderFns } from "./MainSliderNew.vue?vue&type=template&id=39f4c4e2"
import script from "./MainSliderNew.vue?vue&type=script&lang=js"
export * from "./MainSliderNew.vue?vue&type=script&lang=js"
import style0 from "./MainSliderNew.vue?vue&type=style&index=0&id=39f4c4e2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports